export default __webpack_public_path__ + "static/imageABF-c599133bd8bd3805c60592877a70a7b5.png";